/*********************************************************
 * Third Components
*********************************************************/
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

/*********************************************************
 * Components
*********************************************************/
import Table, { Column, Toolbar, DeleteButton } from 'Components/Table';
import { Button } from 'Components';
import AddBoxIcon from '@mui/icons-material/AddBox';
import LandmarkMarkerSvg from 'Components/Map/components/IconsSvg/LandmarkMarkerSvg'

/*********************************************************
 * Css
*********************************************************/
import './style.scss'

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalNewLandmarkGroup,
  showModalEditLandmarkGroup,
  showModalDeleteLandmarkGroups,
  mapLandmarkGetLandmarkGroups
} from 'Redux/actions';

/*********************************************************
 * Class to manage landmark groups elements
*********************************************************/
const LandmarkGroupListEdit = (props) => {

  const { messages } = props
  const landmarksPerPage = 10

  const dispatch = useDispatch()
  const tableRef = useRef();

  const [ selectedItems, setSelectedItems ] = useState([]);

  /*********************************************************
   * Get the redux properties
  *********************************************************/
  const {
    landmarkGroups,
    loadingLandmarkGroups: loading
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);


  useEffect(() => {
    dispatch(mapLandmarkGetLandmarkGroups());
  }, []);

  //** pdf csv functions */
  const getDataToExport = (rows) => {
    let items = rows ? rows : landmarkGroups;
    let data = [];
    items.forEach((item) => {
      const lgroup = item.name;
      const lcolor = item.color;
      data.push([lgroup, lcolor]);
    });

    return data;
  }

  /*********************************************************
   * Columns to export
  *********************************************************/
  const getHeaderToExport = useMemo(() => {
    return [
      messages["realtimemaps_landmarks_group"],
      messages["realtimemaps_landmarks_groupcolor"]
    ];
  });

  /*********************************************************
   * Delete the landmark group
  *********************************************************/
  const onDeleteLandmarkGroups = (selectedLandmarkGroups) => {
    dispatch(showModalDeleteLandmarkGroups(true, selectedLandmarkGroups));
  }

  /*********************************************************
   * Edit the landmark Group
  *********************************************************/
  const onEditLandmarkGroup = (landmarkGroupElement) => dispatch(showModalEditLandmarkGroup(true, landmarkGroupElement))

  /*********************************************************
   * Create a new landmark group
  *********************************************************/
  const onNewLandmarkGroup = () => dispatch(showModalNewLandmarkGroup(true));

  const getTableHeight = () => {
    let screenWidth = window.innerWidth;

    if (screenWidth > 1280 && screenWidth <= 1366) {
      return 200;
    } else if (screenWidth <= 1280) {
      return 100;
    } else {
      return 350;
    }
  }

  return (
    <div className='landmarkGroupDiv'>
      <Table
        viewStyle={'small'}
        data={landmarkGroups || []}
        rowsPerPage={landmarksPerPage}
        loading={loading}
        hideSelectableCheckbox={false}
        //stickyHeader
        name="landmark-groups-grid"
        exportOrientation="landscape"
        getDataToExport={getDataToExport}
        setSelectedItems={(items) => {
          setSelectedItems(items);
        }}
        height={getTableHeight()}
        heightAuto

        /** enable reorder column */
        orderColumn={false}
        /** enable column visibility */
        setColumnVisibility={false}
        /** enable column resizing */
        setColumnResizing={false}
        /** setting preferences */

        //visibleColumns={visibleColumns}
        //columnsOrder={columnOrder}
        //columnResize={columnResize}

        globalHeadersCellStyles={{ background: "white", borderTop: "1px solid #e0e0e0", height: "50px", paddingLeft: "2px" }}

        //watchSearchDataChange={watchSearchDataChange}
        /** hide options */
        hideDownloadButton={false}
        hidePdfOption={false}
        getHeaderToExport={getHeaderToExport}
        paddingRight={1}
        ref={tableRef}
      >
        <Toolbar>
          <Button
            type="icon"
            tooltip={messages["realtimemaps_landmarks_groups_create"]}
            placement="bottom"
            icon={<AddBoxIcon />}
            onClick={() => {
              onNewLandmarkGroup()
            }}
          />

          <DeleteButton
            tooltip={messages["realtimemaps_landmarks_groups_bulk_delete"]}
            onClick={(event) => {
              event.preventDefault();
              onDeleteLandmarkGroups(selectedItems);
            }}
            disabled={selectedItems.length === 0 || (selectedItems.find(item => item?.name === 'Default Group') ? true : false) }
          />
        </Toolbar>
        <Column
          label={' ' + messages['realtimemaps_landmarks_group']}
          field="name"
          headerClassName="centerContent"
        >
          {(item) => {
            return (
              <span>{item?.name}</span>
            )
          }}
        </Column>
        <Column
          label={messages['realtimemaps_landmarks_groupcolor']}
          field="color"
          headerClassName="centerContent"
        >
          {(item) => {
            return (
              <div>
                <LandmarkMarkerSvg color={`#${item?.color}`} name={item?.name || ''} />
              </div>
            )
          }}
        </Column>
        <Column
          label={messages['realtimemaps_landmarks_groupactions']}
          field="actions"
          headerClassName="centerContent"
        >
          {(item) => {
            return (
              <div>
                <Button
                  type="icon"
                  tooltip={messages["realtimemaps_landmarks_groups_edit"]}
                  placement="bottom"
                  icon="edit"
                  onClick={() => {
                    onEditLandmarkGroup(item)
                  }}
                />
                {
                  //this is a business rule, you cannot alter the name of the group 'Default Group'
                  item?.name != 'Default Group'
                  &&
                  <DeleteButton onClick={() => { onDeleteLandmarkGroups([item]) }} />
                }
              </div>
            )
          }}
        </Column>
      </Table>
    </div>
  )

}

export default LandmarkGroupListEdit;